import { Questionnaire, QuestionnaireQuestion, QuestionRegulatoryData } from "../Models/Surveys/SurveyDataModel";
import {QuestionRequirementEvaluator} from "./SurveyResponse/QuestionRequirementEvaluator";
import {
    ComplianceScore,
    ComplianceScoreResult,
    InventoryDetailsResponse
} from "../StateControllers/Survey/SurveyResponse/SurveyResponseModels";

export interface RegulationResponseChangedResult {
    value: any,
    questionIndicesToHide: number[]
}

export class BaseRegulationLogicManager extends QuestionRequirementEvaluator {
    public readonly _questionRegulatoryData: Readonly<QuestionRegulatoryData[]> | null;
    public readonly _selectedInventory: InventoryDetailsResponse | null;
    private readonly _complianceScoreResult: ComplianceScoreResult | null;

    constructor(
        questions: QuestionnaireQuestion[],
        overallQuestionnaire: Questionnaire, 
        questionRegulatoryData: QuestionRegulatoryData[] | null,
        selectedInventory: InventoryDetailsResponse | null,
        complianceScoreResult: ComplianceScoreResult | null
    ) {
        super(questions, overallQuestionnaire);

        this._questionRegulatoryData = questionRegulatoryData;
        this._selectedInventory = selectedInventory;
        this._complianceScoreResult = complianceScoreResult;
    }

    public getIndicesToHideOrShow(question: QuestionnaireQuestion, questionIndex: number): boolean[] {
        let ret: boolean[] = this._questions.map(q => q.hidden ?? false);

        ret = this.getAdditionalQuestionIndicesToHide(question, questionIndex, ret);

        return ret;
    }

    protected getAdditionalQuestionIndicesToHide(question: QuestionnaireQuestion, questionIndex: number, indicesToHideOrShow: boolean[]): boolean[] { return [] }
        
    public onCheckBoxResponseChange(question: QuestionnaireQuestion, answers: string[]): string[] {
        return answers;
    }

    protected customIsQuestionRequired(question: QuestionnaireQuestion){
        return false;
    }

    public isQuestionRequiredBasedOnIngredientData(question: QuestionnaireQuestion): boolean {
        return false;
    }

    public isQuestionRequired(question: QuestionnaireQuestion): boolean {
        return super.isQuestionRequired(question) ||
            this.customIsQuestionRequired(question) ||
            this.isQuestionRequiredBasedOnIngredientData(question);
    }

    // Check if there is at least one substance present from the regulated lists that apply to the question.
    // the question context is in regulatoryData
    public isRegulatedSubstancePresent(regulatoryData: QuestionRegulatoryData): boolean {
        if (this._complianceScoreResult === null) {
            return false;
        }

        if (this._complianceScoreResult.standardMaterialsScore !== ComplianceScore.NonCompliant) {
            return false;
        }

        return this._complianceScoreResult.materialsRootNode.flaggedListIds.containsAnyOf(regulatoryData.regulationListIds);
    }

    // Check if there is at least one substance with CASRN
    public hasAtLeastOneCasrnPresent(): boolean {
        if (!this._selectedInventory?.inventoryRows) {
            return false;
        }

        return this._selectedInventory?.inventoryRows.some(i => i.assignedSubstanceId !== null || i.assignedPrivateSubstanceId !== null || (i.overrideCasNumber?.length ?? 0) > 0);
    }

    public getPageRequiredInfoLocalized(): string | null {
        return null;
    }

    public getRadioColumns(): number[] {
        return [];
    }
}
